import createIcon from '../../createIcon';

/**
 * @component @name Wallpaper
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA0SDExVjJINEMyLjkgMiAyIDIuOSAyIDRWMTFINFY0Wk0xMCAxM0w2IDE4SDE4TDE1IDE0TDEyLjk3IDE2LjcxTDEwIDEzWk0xNyA4LjVDMTcgNy42NyAxNi4zMyA3IDE1LjUgN0MxNC42NyA3IDE0IDcuNjcgMTQgOC41QzE0IDkuMzMgMTQuNjcgMTAgMTUuNSAxMEMxNi4zMyAxMCAxNyA5LjMzIDE3IDguNVpNMjAgMkgxM1Y0SDIwVjExSDIyVjRDMjIgMi45IDIxLjEgMiAyMCAyWk0yMCAyMEgxM1YyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWMTNIMjBWMjBaTTQgMTNIMlYyMEMyIDIxLjEgMi45IDIyIDQgMjJIMTFWMjBINFYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wallpaper = createIcon('Wallpaper', [
  [
    'path',
    {
      d: 'M4 4H11V2H4C2.9 2 2 2.9 2 4V11H4V4ZM10 13L6 18H18L15 14L12.97 16.71L10 13ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM20 2H13V4H20V11H22V4C22 2.9 21.1 2 20 2ZM20 20H13V22H20C21.1 22 22 21.1 22 20V13H20V20ZM4 13H2V20C2 21.1 2.9 22 4 22H11V20H4V13Z',
      key: 'gfrhlt',
    },
  ],
]);

export default Wallpaper;
